<template>
    <div class="Gift">
        <navigation-bar Logo Bell v-if="!isWeb"/>
        <el-row type="flex" class="category-buttons" v-if="!isWeb">
            <el-col :span="6" @click.native="typeChanged('coupon',0)" :class="{'highlight' : activeCategory === 'coupon'}">
                <img v-if="activeCategory === 'coupon'" src="@/assets/images/gift/icon-gift-coupon.svg">
                <img v-else src="@/assets/images/gift/icon-gift-coupon-gray.svg"><br>
                <span>票 券</span>
            </el-col>
            <el-col :span="6" @click.native="typeChanged('oinCard',0)" :class="{'highlight' : activeCategory === 'oinCard'}">
                <img v-if="activeCategory === 'oinCard'" src="@/assets/images/gift/icon-gift-oin-card.svg">
                <img v-else src="@/assets/images/gift/icon-gift-oin-card-gray.svg"><br>
                <span>活動卡</span>
            </el-col>
            <el-col :span="6" @click.native="typeChanged('rewardPoint',0)" :class="{'highlight' : activeCategory === 'rewardPoint'}">
                <img v-if="activeCategory === 'rewardPoint'" src="@/assets/images/gift/icon-gift-bonus.svg">
                <img v-else src="@/assets/images/gift/icon-gift-bonus-gray.svg"><br>
                <span>紅利點數</span>
            </el-col>
                <el-col :span="6" @click.native="typeChanged('loyaltyCard',0)" :class="{'highlight' : activeCategory === 'loyaltyCard'}">
                <img v-if="activeCategory === 'loyaltyCard'" src="@/assets/images/gift/icon-gift-loyalty.svg">
                <img v-else src="@/assets/images/gift/icon-gift-loyalty-gray.svg"><br>
                <span>集點卡</span>
            </el-col>
            <el-col :span="6" @click.native="typeChanged('card',0)" :class="{'highlight' : activeCategory === 'card'}">
                <img v-if="activeCategory === 'card'" src="@/assets/images/gift/icon-gift-card.svg">
                <img v-else src="@/assets/images/gift/icon-gift-card-gray.svg"><br>
                <span>我的卡片</span>
            </el-col>

        </el-row>
        <div class="tabs" v-if="activeCategory!=='oinCard' && activeCategory!=='rewardPoint'">
            <div @click="toSlide(0)" :class="{active : tabNum===0}">
                可使用
            </div>
            <div @click="toSlide(1)" :class="{active : tabNum===1}">
                紀錄
            </div>
        </div>

        <div class="main" v-if="isLogin" ref="main" @scroll="handleScroll">
            <!--todo 活動卡和紅利點數有第二層比較特殊用下面區塊(APP和網頁都是)-->
            <!--todo 不分開寫的話享樂卡的無限載入會一次跑完-->
            <UseItem :valueType="activeCategory" v-if="activeCategory==='oinCard'" :goToPageCardId="goToPageCardId" @triggerEvent="useItemEvent" :isWeb="isWeb"/>
            <UseItem :valueType="activeCategory" v-else-if="activeCategory==='rewardPoint'" :isWeb="isWeb"/>
            <!--todo 其他下面區塊-->
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-if="activeCategory!=='oinCard' && activeCategory!=='rewardPoint' && activeCategory!=='' && !isWeb">
                    <div class="swipe-content" ref="coupon" @scroll="handleScroll">
                        <div class="swipe-con">
                            <UseItem :valueType="activeCategory" v-if="this.tabNum===0" :executeType="routeParams.executeType"/>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide v-if="activeCategory!=='oinCard' && activeCategory!=='rewardPoint' && activeCategory!=='' && !isWeb">
                    <div class="swipe-content">
                        <div class="swipe-con">
                            <RecordItem :valueType="activeCategory" v-if="this.tabNum===1" :isWeb="isWeb"/>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <!--todo 其他網頁下面區塊-->
            <template v-if="activeCategory!=='oinCard' && activeCategory!=='rewardPoint' && activeCategory!=='' && isWeb">
                <UseItem :valueType="activeCategory" v-if="this.tabNum===0" :executeType="routeParams.executeType" :isWeb="isWeb"/>
                <RecordItem :valueType="activeCategory" v-if="this.tabNum===1" :isWeb="isWeb"/>
            </template>
        </div>

        <comm-dialog class="dialog-dark"
                     v-if="!isLogin"
                     :value="!isLogin"
                     :outerContent="'請先登入'"
                     :isModal="false"
                     @result="onCommDialogClose"/>

    </div>
</template>

<script>
    import CommDialog from '@/components/CommDialog.vue';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import UseItem from'../gift/components/UseItem'
    import RecordItem from'../gift/components/RecordItem'
    let vm = null;
    export default {
        name: 'Gift',
        components: {
            CommDialog,
            Swiper,
            SwiperSlide,
            UseItem,
            RecordItem,
        },
        props: {
            isWeb: Boolean,
            isTypeWeb: {default: 'rewardPoint'},
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
                activeCategory: '',

                //目前索引值(可使用 紀錄)
                tabNum: 0,
                //swiper套件設定
                swiperOptions: {
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                        },
                    },
                    breakpoints: {
                        //電腦版不給左右滑動
                        1024: {
                            noSwipingSelector: '.swiper-slide',
                            //autoHeight: true,
                            slideSpeed: 0,
                            speed: 0,
                        }
                    },
                },
                routeParams: {
                  activeCategory: this.$route.query.activeCategory !== undefined ? this.$route.query.activeCategory : this.$route.params.activeCategory,
                  activeTab: this.$route.query.activeTab  !== undefined ? this.$route.query.activeTab : this.$route.params.activeTab,
                  executeType: this.$route.query.executeType  !== undefined ? this.$route.query.executeType : this.$route.params.executeType || '',
                },
                goToPageCardId: this.$route.params.goToPageCardId? this.$route.params.goToPageCardId: 0,   //預設要跳到詳細資訊頁面的卡片id

                //判斷往上或往下滾動-篩選上滑或展開使用
                x: 0,
            }
        },
        created() {
            vm = this;
        },
        mounted () {
            if (this.isLogin) {
              if (this.routeParams.activeCategory === undefined && this.routeParams.activeTab === undefined) {
                this.typeChanged('coupon',0)
              } else {
                let activeIndex = this.routeParams.activeTab === 'use' ? 0 : 1
                this.typeChanged(this.routeParams.activeCategory, activeIndex);
              }
            }
            if(this.isWeb){
                this.typeChanged( this.isTypeWeb,0)
            }
        },
        methods: {
            typeChanged(activeCategory, activeIndex) {
                this.activeCategory=activeCategory
                this.$refs.mySwiper.$swiper.slideTo(activeIndex,0)
            },
            toSlide(index) {
                if(!this.isWeb){
                    this.$refs.mySwiper.$swiper.slideTo(index)
                }else {
                    //單店網頁版用
                    this.tabNum = index
                }
            },
            tabNumber(index) {
                this.tabNum=index
            },
            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                if (result) {
                    this.$router.push({name: 'Login'});
                } else {
                    this.$router.go(-1)
                }
            },
            useItemEvent(obj) {
              let self = this;
              let event = obj.event;
            },
            //頁面滾動時 最快到期 最新取得 按鈕往上滑被收起，往下滑被展開
            handleScroll(){
                let h;
                //活動卡的捲動
                if(this.activeCategory==='oinCard' || this.activeCategory==='rewardPoint'){
                    h = this.$refs.main.scrollTop;
                //其他票種的捲動
                }else{
                    h = this.$refs.coupon.scrollTop;
                }
                let scroll = h - this.x;
                this.x = h;

                if (document.getElementsByClassName('sub-tab').length > 0) {
                    if (this.$public.notNull(document.getElementsByClassName('sub-tab')[0].classList)) {
                        if (scroll<=0 || h<80 ){
                            //滾動往下或正在按分頁按鈕時
                            document.getElementsByClassName('sub-tab')[0].classList.add("top-button-show");
                        } else{
                            //滾動往上
                            document.getElementsByClassName('sub-tab')[0].classList.remove("top-button-show");
                        }
                    }
                }
            },

            /** eventBus 數據傳遞 */
            handleEvent: function (data) {
                if (this.$public.notNull(data)) {
                    this.storeInfo = data;
                }
            },

        },
        watch: {
          '$store.state.changePageData.isChangePage': {
            handler:function () {
              if(this.$store.state.changePageData.isChangePage) {
                let activeIndex = this.$store.state.changePageData.activeTab === 'use' ? 0 : 1
                if(this.$store.state.changePageData.activeCategory !== this.activeCategory) {
                  this.typeChanged(this.$store.state.changePageData.activeCategory, activeIndex);
                }
                this.$store.commit('setChangePageData',{
                  isChangePage: false,
                });
              }
            },
            deep:true,
            immediate:true,
          },
        }
    }
</script>

<style lang="less" scoped src="../../less/gift.less"/>